<template>
  <div>
    <form @submit.prevent>
      <b-form-group label-for="filterBy" class="border-bottom-form">
        <div class="d-flex">
          <div class="row flex-1-0">
            <div class="col col-6">
              <b-form-group
                label="Đơn vị"
                label-class="font-weight-bold font-size-16"
              >
              <div class="d-flex flex-1-0">
                <treeselect
                  :clearable="true"
                  :normalizer="normalizer"
                  :options="danhSachDonViBanDau || []"
                  :show-count="true"
                  :value="requestForm.donViId"
                  no-children-text="Không có đơn vị con"
                  placeholder="Chọn đơn vị"
                  ref="chonCayDonVi"
                  v-model="requestForm.donViId"
                  @input="layDanhSachNguoiDung"
                  class="tree-don-vi flex-1-0"
                >
                  <label
                    :class="labelClassName"
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                  >
                    {{ node.label }}
                    <span
                      :class="countClassName"
                      v-if="shouldShowCount && count > 0"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
                <b-form-checkbox
                  v-model="requestForm.isGetAll"
                  class="mt-2 ml-3"
                  @change="onChangeGetAll"
                >
                  Tất cả
                </b-form-checkbox>
              </div>
              </b-form-group>
            </div>
            <div class="col col-6">
              <b-form-group
                label="Chức vụ"
                label-class="font-weight-bold font-size-16"
              >
                <b-form-input
                  v-model="requestForm.ChucVu"
                  id="filterBy"
                  type="text"
                  required
                  placeholder="Nhập chức vụ"
                  @keyup.enter="layDanhSachNguoiDung"
                />
                <b-icon class="icon-search-form" icon="search" />
              </b-form-group>
            </div>
          </div>
        </div>
      </b-form-group>
    </form>
    <div class="box-form-result">
      <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
      <DataTable
        :value="danhSachNguoiDungNoiBo"
        :loading="isLoadingTable"
        :selection.sync="selectedCanBo"
      >
        <Column
          field="id"
          headerStyle="width: 40px"
          header=""
          bodyStyle="text-align: center"
          selectionMode="multiple"
          :filter-header-class="readonly ? 'd-none' : ''"
          :body-class="readonly ? 'd-none' : ''"
          :header-class="readonly ? 'd-none p-2' : 'p-2'"
        >
        </Column>
        <Column
          field="stt"
          dataKey="stt"
          headerStyle="width: 40px"
          headerClass="p-2"
          header="STT"
          bodyStyle="text-align: center"
        >
          <template #filter> </template>
          <template #body="slotProps">
            <span>{{
              (requestInformation.pageIndex - 1) * requestInformation.pageSize +
              slotProps.index +
              1
            }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="userName"
          header="Tên đăng nhập"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.UserName"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.userName }}</span>
          </template>
        </Column>

        <Column
          filterMatchMode="custom"
          field="name"
          header="Họ tên"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.Name"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.name }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="donVi"
          header="Đơn vị"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.DonVi"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.donVi }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="chucVu"
          header="Chức vụ"
          headerStyle="minWidth: 200px"
        >
          <template #filter>
            <InputText
              type="text"
              class="p-column-filter"
              placeholder="Tìm kiếm"
              v-model="requestForm.ChucVu"
              @change="layDanhSachNguoiDung"
            />
          </template>
          <template #body="slotProps">
            <span>{{ slotProps.data.chucVu }}</span>
          </template>
        </Column>
        <Column
          filterMatchMode="custom"
          field="thaoTac"
          header="Thao tác"
          headerStyle="width: 100px"
        >
          <template #body="slotProps">
            <div class="text-center">
              <b-icon
                icon="plus-circle-fill"
                v-b-popover.hover.top="'Thêm người dùng vào nhóm'"
                class="cursor-pointer color-red ml-2 text-success"
                @click="chonNguoiDung(slotProps.data.id)"
              />
            </div>
          </template>
        </Column>
        <template #empty
          ><div class="text-center">Không có dữ liệu</div></template
        >
        <template #loading
          ><div class="text-center">Đang tải dữ liệu ...</div>
        </template>
      </DataTable>
    </div>
    <BasePagination
      class="mt-3"
      :total-pages="totalPages"
      :total-rows="totalRows"
      :current-page="requestInformation.pageIndex"
      @changePages="onChangePages($event)"
      @changeNum="onChangeNum($event)"
    />
    <div style="text-align: center" class="float-right mt-4">
      <base-button
        :disabled="selectedCanBo.length === 0"
        button="Thêm mới"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="primary"
        @click="chonDanhSachNguoiDung()"
        >Tạo</base-button
      >
      <base-button
        button="Đóng"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="outline-secondary"
        @click="hideModal()"
        >Hủy
      </base-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import _isNil from "lodash/isNil";
import QuanLyNguoiDung from "@/mixins/QuanLyNguoiDung";
import { LOI_CHUA_CHON_NGUOI_DUNG } from "@/constants/message";
import {
  NO_RESULTS_TEXT,
  TREE_SELECT_PLACEHOLDER
} from "@/constants/constants";
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "DanhSachNguoiDungHeThong",
  mixins: [QuanLyNguoiDung],
  components: { Treeselect },
  watch: {
    selectedCanBo: {
      handler() {
        this.danhSachIdNguoiDungDaChon = (this.selectedCanBo || []).map(
          x => x.id
        );
      },
      deep: true
    },
    danhSachNguoiDung: {
      handler() {
        this.totalPages = this.danhSachNguoiDung.totalPage;
        this.totalRows = _isNil(this.danhSachNguoiDung.totalCount)
          ? 0
          : this.danhSachNguoiDung.totalCount;

        this.danhSachNguoiDungNoiBo = this.layDanhSachNguoiDungNoiBo(
          this.danhSachNguoiDung
        );
      },
      deep: true
    }
  },
  data() {
    return {
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      TREE_SELECT_PLACEHOLDER: TREE_SELECT_PLACEHOLDER,
      donViId: null,
      danhSachIdNguoiDungThemMoi: [],
      requestInformation: {},
      requestForm: {},
      selectedCanBo: []
    };
  },
  props: {
    groupId: {
      type: String,
      require: false
    }
  },
  computed: {
    ...mapGetters({
      danhSachNguoiDung: "group/danhSachUserNotInGroup",
      danhSachDonVi: "donVi/danhSachDonVi"
    }),
    danhSachDonViBanDau() {
      if (!this.danhSachDonVi) {
        return [];
      }
      let danhSach = [];
      danhSach = this.danhSachDonVi.map(item => {
        return {
          Task_ID: item.id,
          Task_Parent_ID: item.iD_DonVi_Cha,
          Label: item.tenDonVi,
          Childrens: [],
          ...item
        };
      });
      return this.list_to_tree(danhSach);
    }
  },
  created() {
    this.layDanhSachNguoiDung();
    this.$store.dispatch("donVi/layDanhSachDonViCha", {}).then(() => {});
  },
  methods: {
    onChangeGetAll() {
      this.$nextTick(() => {
        this.layDanhSachNguoiDung();
      });
    },
    hideModal() {
      this.$emit("close");
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    treeselectClass(valid) {
      return {
        "treeselect-invalid": valid
      };
    },
    normalizer(node) {
      return {
        children: _isEmpty(node.children) ? undefined : node.children
      };
    },
    list_to_tree(list) {
      if (list.length > 0) {
        var map = {},
          node,
          roots = [],
          i;
        for (i = 0; i < list.length; i += 1) {
          map[list[i].Task_ID] = i; // initialize the map
          list[i].Childrens = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.Task_Parent_ID !== this.guidEmpty) {
            // if you have dangling branches check that map[node.parentId] exists
            if (list[map[node.Task_Parent_ID]] != null) {
              list[map[node.Task_Parent_ID]].Childrens.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens
              });
            } else {
              roots.push({
                id: node.Task_ID,
                label: node.Label,
                parentId: node.Task_Parent_ID,
                children: node.Childrens
              });
            }
          } else {
            roots.push({
              id: node.Task_ID,
              label: node.Label,
              parentId: node.Task_Parent_ID,
              children: node.Childrens
            });
          }
        }
        return roots;
      }
      return list;
    },
    chonNguoiDung(nguoiDungId) {
      this.danhSachIdNguoiDungDaChon = [nguoiDungId];
      this.capNhatNguoiDungTrongVaiTro(true);
      // this.danhSachNguoiDungNoiBo = this.danhSachNguoiDungNoiBo.filter(
      //   (x) => x.id != nguoiDungId
      // );
    },
    chonDanhSachNguoiDung() {
      if (_isEmpty(this.selectedCanBo) || this.selectedCanBo.length === 0) {
        this.$toasted.clear();
        this.$toasted.global.showErrorMessage({
          message: LOI_CHUA_CHON_NGUOI_DUNG
        });
        return;
      }
      this.capNhatNguoiDungTrongVaiTro(true);
    },
    capNhatNguoiDungTrongVaiTro(closeModal) {
      this.$emit("themNguoiDungVaoGroup", closeModal);
    },
    layDanhSachNguoiDung() {
      const payload = {
        ...this.requestInformation,
        ...this.requestForm,
        groupId: this.groupId
      };
      this.isLoadingTable = true;
      this.$store
        .dispatch("group/layDanhSachUserNotInGroup", payload)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    layDanhSachNguoiDungNoiBo(nguoiDungGomQuyen) {
      if (_isEmpty(nguoiDungGomQuyen.items)) {
        return [];
      }
      return nguoiDungGomQuyen.items.map((item, index) => {
        return {
          checkbox: true,
          stt:
            (this.requestInformation.pageIndex - 1) *
              this.requestInformation.pageSize +
            index +
            1,
          id: _isNil(item.id) ? "" : item.id,
          userId: _isNil(item.userId) ? "" : item.userId,
          userName: _isNil(item.userName) ? "" : item.userName,
          name: _isNil(item.name) ? "" : item.name,
          email: _isNil(item.email) ? "" : item.email,
          donVi: _isNil(item.donVi) ? "" : item.donVi,
          chucVu: _isNil(item.chucVu) ? "" : item.chucVu,
          thaoTac: null
        };
      });
    }
  }
};
</script>

<style scoped>
.icon-search-form {
  position: absolute;
  right: 25px;
  top: 40px;
}
</style>
